<template>
  <!-- 新增和编辑使用同一个 -->
  <div class="add-eidt-data-page">
  <add-form ref="libForm" @submit="realSubmit"></add-form>
  </div>
</template>
<script>
import addForm from './components/addForm'
import { mainDataAdd, setEditMaindata } from '@/api/goodStand'
import { msg } from '@/utils/index'
export default {
  name: 'addAndEditData',
  components: { addForm },
  data() {
    return {
      // btnDisabled: false // 子组件提交保存按钮的状态
    }
  },
  mounted() {
    const titles = {
      'kehuData': '新增主数据',
      'companyData': '新增生产企业',
      'shangyeData': '新增商业企业',
      'yiliaoData': '新增医疗机构',
      'yaodianData': '新增药店',
      'yiyuanData': '新增医院',
      'zhongduanData': '新增第三终端'
    }
    if (this.$route.name === 'addData') {
      this.$store.dispatch('setPage', {
        title: titles[this.$route.params.type],
        url: ''
      })
    } else {
      this.$store.dispatch('setPage', {
        title: '编辑',
        url: ''
      })
    }
  },
  methods: {
    // 新增数据和保存编辑
    realSubmit(params) {
      // this.btnDisabled = true
      this.$refs.libForm.changeSunDisabled('true')
      if (this.$route.name === 'addData') {
        mainDataAdd(params, this.$route.params.type).then(res => {
          this.dealRes(res)
        })
      } else {
        setEditMaindata(Object.assign({}, params, { id: this.$route.params.id }), this.$route.params.type).then(res => {
          this.dealRes(res)
        })
      }
    },
    dealRes(res) {
      // this.btnDisabled = false
      this.$refs.libForm.changeSunDisabled()
      if (res.code === 0) {
        // window.close()
        window.open('about:blank', '_self').close()
      } else {
        msg.call(this, res.msg)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.add-eidt-data-page {
  padding: 10px;
}
</style>

